<template>
  <div id="page-detail-candidate">
    <div class="row mr-0 ml-0 pl-0 pr-0">
      <div class="col-lg-12 col-xs-12">
        <div class="mt-3 mb-3 label-bold">
          <span class="text-truncate p-2 f20">VAGA </span>
          <span class="color-purple">{{ job_name }}</span>
        </div>
      </div>
      <div class="col-lg-12 mb-3">
        <div class="row">
          <div class="col-lg-3">
            <button
              :class="{ hide: !havePrevius() }"
              class="btn btn-primary full radius-0"
              @click="nextCandidate(havePrevius(), -1)"
            >
              <i class="fas mr-2 fa-chevron-left"></i>
              CANDIDATO(A) ANTERIOR
            </button>
          </div>
          <div class="col-lg-6"></div>
          <div class="col-lg-3">
            <button
              :class="{ hide: !haveNext() }"
              class="btn btn-primary full radius-0"
              @click="nextCandidate(haveNext(), +1)"
            >
              PRÓXIMO CANDIDATO(A)
              <i class="fas ml-2 fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-xs-12">
        <div
          v-show="!show_resume"
          :style="{
            borderLeftColor: this.colorBorder,
            borderLeftWidth: '5px',
          }"
          class="bg-purple color-white"
        >
          <div class="row color-white direction-box">
            <div class="pr-5">
              <img
                v-if="avatar != ''"
                :src="avatar"
                class="thumb-box mt-3 mb-2"
              />
            </div>
            <div class="content-items mb-3 pt-4 pb-2 text-truncate">
              <p class="mb-0"></p>
              <div class="flex align-items-center">
                <div class="flex align-items-center">
                  <div v-if="edit_name === false">
                    <span>
                      <b>{{ candidate.name }}</b>
                    </span>
                    <font-awesome-icon
                      class="dark_grey ml-2"
                      icon="pencil-alt"
                      style="font-size: 15px !important"
                      @click="edit_name = true"
                    />
                  </div>
                  <div v-else class="flex align-items-center">
                    <input
                      v-model="candidate.name"
                      class="form-control no_border bg_grey f12"
                      style="height: 20px"
                    />
                    <font-awesome-icon
                      class="color-green ml-2"
                      icon="check"
                      @click="updateName()"
                    />
                  </div>
                </div>
              </div>
              <div class="box-icons">
                <div class="flex align-items-center">
                  <div class="flex align-items-center">
                    <font-awesome-icon
                      class="mr-2 color-purple f15"
                      icon="envelope"
                    />
                    <div v-if="edit_email === false">
                      <span>
                        <a
                          :href="`mailto:${candidate.email}`"
                          class="f12 color-white"
                        >
                          {{ candidate.email }}
                        </a>
                      </span>
                      <font-awesome-icon
                        class="dark_grey ml-2"
                        icon="pencil-alt"
                        style="font-size: 15px !important"
                        @click="edit_email = true"
                      />
                    </div>
                    <div v-else class="flex align-items-center">
                      <input
                        v-model="candidate.email"
                        class="form-control no_border bg_grey f12"
                        style="height: 20px"
                      />
                      <font-awesome-icon
                        class="color-green ml-2"
                        icon="check"
                        @click="updateEmail()"
                      />
                    </div>
                  </div>
                </div>
                <span
                  v-if="candidate.last_role || candidate.last_business"
                  class="f12 color-white"
                >
                  {{ candidate.last_role }} / {{ candidate.last_business }}
                </span>
                <div style="display: flex">
                  <i
                    :class="`${
                      tagName ? 'mt-1' : 'mt-2'
                    } fas f12 mr-2 fa-tags color-purple`"
                  />
                  <div
                    :style="
                      tagColor
                        ? `background-color: ${tagColor}; text-shadow: 0px 0px 3px black;`
                        : ''
                    "
                    class="color-white center px-1 font-weight-bold"
                  >
                    <span class="f12 pointer" @click="showTagOverview">
                      {{ tagName != "" ? tagName : "Sem Etiqueta" }}
                    </span>
                  </div>
                </div>
                <div class="flex align-items-center">
                  <font-awesome-icon
                    class="mr-2 color-purple f15"
                    icon="phone-alt"
                  />
                  <div v-if="edit_number === false">
                    <span class="color-white f12">
                      {{ candidate.mobile_phone }}
                    </span>
                    <font-awesome-icon
                      class="dark_grey ml-2"
                      icon="pencil-alt"
                      style="font-size: 15px !important"
                      @click="edit_number = true"
                    />
                  </div>
                  <div v-else class="flex align-items-center">
                    <input
                      v-model="candidate.mobile_phone"
                      v-mask="
                        candidate.mobile_phone &&
                        candidate.mobile_phone.length > 18
                          ? '+## (##) #####-####'
                          : '+## (##) ####-####'
                      "
                      class="form-control no_border bg_grey f12"
                      style="height: 20px"
                    />
                    <font-awesome-icon
                      class="color-green ml-2"
                      icon="check"
                      @click="updatePhone()"
                    />
                  </div>
                </div>
                <div v-if="whatsapp != ''">
                  <i class="fab f15 mr-2 fa-whatsapp color-purple"></i>
                  <a
                    :href="`https://wa.me/${whatsapp}?text=%20`"
                    class="color-white f12"
                    target="_blank"
                  >
                    WHATSAPP
                  </a>
                </div>
                <div v-if="talent_bank_id > 0 && !is_limited">
                  <span class="f12 pointer color-grey">
                    <i class="fas mr-2 fa-info-circle color-purple"></i>
                    <a
                      :href="`/recruiters/talent_banks/${this.talent_bank_id}/candidate/`"
                      class="color-white"
                      target="_blank"
                      >BANCO DE TALENTOS</a
                    >
                  </span>
                </div>
                <div class="pointer" @click="showBigfive">
                  <span class="f12 pointer color-white">
                    <i class="fas mr-2 fa-address-book color-purple mr-1"></i>
                    BIGFIVE
                  </span>
                </div>
                <div class="pointer" @click="openWhatsappSolcitation">
                  <i class="fas mr-2 fa-share-square color-purple f12"></i>
                  <span class="f12 pointer color-white">
                    SOLICITAR PARA COMPLETAR DADOS
                  </span>
                </div>
              </div>
              <div v-if="custom_flags != null">
                <div v-for="(flag, index) in custom_flags" :key="index">
                  <div v-show="candidate.id <= flag.value">
                    <i
                      :color="flag.color"
                      class="fas mr-2 fa-exclamation-triangle f12"
                    />
                    <span class="f12 pointer color-white text-uppercase">
                      {{ flag.message }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="!show_resume"
          class="card-body-noBorder card-light-grey mt-3"
        >
          <BigfiveShow
            v-if="candidate.uid"
            :candidate_uid="candidate.uid"
            :is_limited="is_limited"
            :no_next="true"
            :only_graph="true"
          />
        </div>
        <div v-show="!recruiter" class="card card-body bg-white mt-3 card-body">
          <p>AVALIE ESSE CANDIDATO(A)</p>
          <AvaliationLike
            v-if="!load_candidate"
            :apply_id="apply.uid"
            :deslike_candidate="apply.deslike_candidate"
            :job_id="apply.job_id"
            :like_avaliation="apply.like_avaliation"
            :like_candidate="apply.like_candidate"
            :recruiter="is_recruiter"
            :star_candidate="apply.star_candidate"
          />
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="bg-purple color-white">
              <div
                class="row container pointer"
                @click="show_candidate_data = !show_candidate_data"
              >
                <p class="pl-3 pt-3">
                  <b v-if="is_limited">DADOS ADICIONAIS</b>
                  <b v-else>MAIS DADOS DO CANDIDATO</b>
                  <font-awesome-icon
                    v-if="show_candidate_data"
                    icon="chevron-up"
                  />
                  <font-awesome-icon v-else icon="chevron-down" />
                </p>
              </div>
              <div
                v-if="show_candidate_data"
                class="container"
                style="
                  background-color: white;
                  border: 1px solid #e6e6e6;
                  color: black;
                "
              >
                <div class="col-lg-12 mt-4">
                  <div class="col-lg-12 col-xs-12">
                    <div class="row mt-1 mb-2">
                      <div class="col-lg-6 col-xs-12">
                        <span>SALARIO</span>
                      </div>
                      <div class="col-lg-6 col-xs-12">
                        <span>
                          {{ candidate.remuneration || "Não definido" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-6 col-xs-12">
                        <span>CIDADE NATAL</span>
                      </div>
                      <div class="col-lg-6 col-xs-12">
                        <span>
                          {{
                            candidate.hometown_attributes
                              ? `${candidate.hometown_attributes.name}/${candidate.hometown_state_attributes.name}`
                              : `Não definido`
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-6 col-xs-12">
                        <span>GENÊRO</span>
                      </div>
                      <div class="col-lg-6 col-xs-12">
                        <span>
                          {{ getGender(candidate.gender) || "Não definido" }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-6 col-xs-12">
                        <span>ETNIA</span>
                      </div>
                      <div class="col-lg-6 col-xs-12">
                        <span>
                          {{
                            getEthnicity(candidate.ethnicity) || "Não definido"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1">
                      <div class="col-lg-6 col-xs-12">
                        <span>ORIENTAÇÃO SEXUAL</span>
                      </div>
                      <div class="col-lg-6 col-xs-12">
                        <span>
                          {{
                            getSexualOrientation(
                              candidate.sexual_orientation
                            ) || "Não definido"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1 mb-3">
                      <div class="col-lg-6 col-xs-12">
                        <span>PCD</span>
                      </div>
                      <div class="col-lg-6 col-xs-12">
                        <span>
                          {{
                            candidate.is_pcd ? candidate.pcd_description : "Não"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row mt-1 mb-1">
                      <div class="col-lg-6 hide col-xs-12">
                        <span>COMPETENCIAS</span>
                      </div>
                      <div class="col-lg-6 col-xs-12">
                        <div
                          v-for="skill in skills"
                          :key="skill.id"
                          class="skill_uni"
                        >
                          {{ skill.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="bg-purple color-white">
              <p class="pl-3 pt-3 mb-3">
                <b v-if="is_limited">STATUS NO PROCESSO</b>
                <b v-else>CLASSIFIQUE ESSE CANDIDATO(A)</b>
              </p>
              <div>
                <select
                  v-model="select_process_id"
                  class="form-control"
                  @change="updateApply()"
                >
                  <option
                    v-for="process in select_process"
                    :key="process.id"
                    :value="process.id"
                  >
                    {{ process.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="bg-purple color-white">
              <p class="pl-3 pt-3">
                <b v-if="is_limited">PORTFÓLIO</b>
                <b v-else>PORTFÓLIO CANDIDATO(A)</b>
              </p>
              <div
                class="pl-3 pb-3 pt-3 d-flex justify-content-start"
                style="
                  background-color: white;
                  border: 1px solid #e6e6e6;
                  color: black;
                "
              >
                <i class="fas fa-paperclip" style="font-size: 36px"></i>
                <div class="col-lg-10">
                  <div class="text-truncate">
                    <a
                      v-if="candidate.linkedin_url != ''"
                      :href="candidate.linkedin_url"
                      class="pl-1"
                      target="_blank"
                    >
                      {{ this.candidate.linkedin_url }}
                    </a>
                    <span v-if="this.candidate.linkedin_url == null">
                      NÃO INFORMADO
                    </span>
                  </div>
                  <div class="text-truncate">
                    <a
                      v-if="candidate.personal_portfolio != ''"
                      :href="candidate.personal_portfolio"
                      class="pl-1 pt-1"
                      target="_blank"
                    >
                      {{ candidate.personal_portfolio }}
                    </a>
                    <span
                      v-if="candidate.personal_portfolio == ''"
                      class="pl-1"
                    >
                      NÃO INFORMADO
                    </span>
                  </div>
                  <div class="text-truncate">
                    <a
                      v-if="candidate.personal_site != ''"
                      :href="candidate.personal_site"
                      class="pl-1 pt-1"
                      target="_blank"
                    >
                      {{ this.candidate.personal_site }}
                    </a>
                    <span v-if="candidate.personal_site == ''" class="pl-1">
                      NÃO INFORMADO
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="bg-purple color-white">
              <p class="pl-3 pt-3"><b>CURRÍCULO</b></p>
              <div
                class="pl-3 pb-3 pt-3 d-flex justify-content-start"
                style="
                  background-color: white;
                  border: 1px solid #e6e6e6;
                  color: black;
                "
              >
                <div class="cardy-body-noBorder card-light-grey mt-3">
                  <Resume
                    v-if="candidate.curriculum_text"
                    :id="candidate.id"
                    :account_uid="account_uid"
                    :resume="candidate.curriculum_text"
                    :uid="candidate.uid"
                  />
                  <div v-else>
                    <span> Nenhum currículo encontrado </span>
                    <CurriculumUpload :id="candidate.id" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!user_manager" class="row mt-4 mb-2">
          <div class="col-lg-12">
            <div class="card-body-noBorder">
              <div
                class="bg-purple d-flex justify-content-center align-center"
                style="height: 50px"
              >
                <span v-if="is_limited" class="color-white pt-3 pb-3">
                  COMPARTILHAR PERFIL
                </span>
                <span v-else class="color-white pt-3 pb-3">
                  COMPARTILHAR CANDIDATO(A)
                </span>
              </div>
              <div>
                <div class="col-12 mt-2">
                  <h4>SELECIONE UMA LISTA</h4>
                </div>
                <div class="col-12 mb-2">
                  <VueSuggestion
                    :queryParamName="`job_id=${job_id}&search`"
                    :whenSelected="shortlistSelected"
                    placeholder="COMECE A DIGITAR PARA BUSCAR"
                    responseDataName="shortlists"
                    searchURL="/recruiters/shortlists/"
                  />
                </div>
                <div class="col-12 pt-4">
                  <h4>CRIAR NOVA LISTA</h4>
                </div>
                <div class="col-12 pt-1">
                  <label>NOME</label>
                  <input
                    v-model="shortlist_name"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="col-12 pt-1">
                  <button
                    :disabled="load_share"
                    class="btn mt-3 mb-3 full btn-success"
                    type="button"
                    @click="createShortlist"
                  >
                    <span v-show="!load_share">ADICIONAR</span>
                    <div
                      v-show="load_share"
                      class="spinner-border text-light"
                      role="status"
                    >
                      <span class="sr-only"></span>
                    </div>
                  </button>
                </div>
                <div class="col-12 pt-4">
                  <h4>LISTAS CADASTRADAS</h4>
                </div>
                <div v-if="shortlists.length > 0" class="col-lg-12 col-xs-12">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <td class="center">#</td>
                        <td class="center">Nome</td>
                        <td>Gestores(as)</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(shortlist, index) in shortlists"
                        :key="shortlist.id"
                        class="h-auto"
                      >
                        <td class="center">
                          <div
                            class="d-inline pointer"
                            @click="removeShortlist(index, shortlist.id)"
                          >
                            <i class="fas fa-trash color-red ml-1 scale_1"></i>
                          </div>
                        </td>
                        <td class="center">
                          <span
                            :title="shortlist.name"
                            class="text-truncate d-inline-block"
                            style="max-width: 100px"
                            >{{ shortlist.name }}</span
                          >
                        </td>
                        <td>
                          <table>
                            <tr
                              v-for="(
                                manager, manager_index
                              ) in shortlist.managers"
                              :key="`manager_${manager_index}_${index}`"
                              class="h-auto"
                            >
                              <td class="center">
                                <div
                                  class="d-inline"
                                  @click="
                                    removeManager(
                                      index,
                                      manager_index,
                                      manager.id
                                    )
                                  "
                                >
                                  <i
                                    class="fas fa-trash color-red ml-1 scale_1"
                                  ></i>
                                </div>
                              </td>
                              <td>
                                <span
                                  :title="manager.name"
                                  class="text-truncate d-inline-block"
                                  style="max-width: 100px"
                                  >{{ manager.manager_name }}</span
                                >
                              </td>
                              <td class="center">
                                <span
                                  v-clipboard:copy="manager.url"
                                  v-clipboard:success="onCopy"
                                  class="pointer color"
                                >
                                  <font-awesome-icon icon="paperclip" />
                                </span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-12 pt-4">
                  <h4>GESTORES(AS)</h4>
                </div>
                <SelectManagers
                  v-model="managers"
                  :is_limited="is_limited"
                  :job_id="job_id"
                  :truncate="true"
                  inputClasses="form-control mt-2"
                />
                <textarea
                  v-model="message"
                  class="form-control mt-2"
                  placeholder="Mensagem"
                  rows="6"
                ></textarea>
                <button
                  :disabled="load_share"
                  class="btn-blue-light mt-3 mb-3"
                  type="button"
                  @click="shareCandidate"
                >
                  <span v-show="!load_share">ENVIAR</span>
                  <div
                    v-show="load_share"
                    class="spinner-border text-light"
                    role="status"
                  >
                    <span class="sr-only"></span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!user_manager" class="row mr-0 ml-0 pl-0 pr-0">
          <div class="col-lg-12 bg-white p-0 m-0">
            <div
              class="bg-purple d-flex justify-content-center align-center"
              style="height: 50px"
            >
              <span v-if="is_limited" class="color-white pt-3 pb-3">
                ADICIONAR PERFIL EM OUTRA VAGA​
              </span>
              <span v-else class="color-white pt-3 pb-3">
                COPIAR CANDIDATO(A) PARA OUTA VAGA
              </span>
            </div>
            <div class="row mb-2">
              <div class="col-lg-12 col-xs-12">
                <vue-suggestion
                  v-model="job_selected"
                  :itemTemplate="itemTemplate"
                  :items="jobs"
                  :setLabel="setLabel"
                  class="mt-3 mb-3"
                  placeholder="Título da vaga"
                  style="border-radius: 0px !important"
                  @changed="inputChange"
                  @selected="itemSelected"
                ></vue-suggestion>
              </div>
              <transition name="fade">
                <div
                  v-if="job_selected.id"
                  class="col-lg-12 col-xs-12 card bg-white mt-1"
                >
                  <div v-if="answers.length > 0">
                    <div>
                      <label class="mt-3 label-bold"
                        >IMPORTAR PERGUNTAS DESSA VAGA?</label
                      >
                    </div>
                    <label>
                      <input
                        v-model="import_answer"
                        name="import_answer"
                        type="radio"
                        value="1"
                      />
                      SIM
                    </label>
                    <label>
                      <input
                        v-model="import_answer"
                        name="import_answer"
                        type="radio"
                        value="0"
                      />
                      NÃO
                    </label>
                  </div>

                  <label class="mt-3">
                    <input v-model="visibility" type="checkbox" />
                    <span class="label-bold">
                      DEIXAR CANDIDATO INVISÍVEL PARA ESSA VAGA
                    </span>
                  </label>
                  <button
                    :disabled="load_copy"
                    class="btn-blue-light mt-3 mb-3"
                    @click="copyCandidate"
                  >
                    <span v-show="!load_copy">Copiar candidato</span>
                    <div
                      v-show="load_copy"
                      class="spinner-border text-light"
                      role="status"
                    >
                      <span class="sr-only"></span>
                    </div>
                  </button>
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div v-if="!user_manager" class="row mr-0 ml-0 mb-5 pl-0 pr-0">
          <div class="col-lg-12 bg-white p-0 m-0">
            <div
              class="bg-purple d-flex justify-content-center align-center"
              style="height: 50px"
            >
              <span v-if="is_limited" class="color-white pt-3 pb-3">
                ENVIAR NOVA SENHA DE CADASTRO​
              </span>
              <span v-else class="color-white pt-3 pb-3">
                ALTERAR SENHA DO CANDIDATO(A)
              </span>
            </div>
            <div class="row mt-3 mb-2">
              <div class="col-lg-12 col-xs-12">
                <input
                  v-model="password"
                  class="form-control width100"
                  placeholder="Senha"
                  type="password"
                />
              </div>
              <div class="col-lg-12 col-xs-12 pt-3">
                <input
                  v-model="confirm_password"
                  class="form-control width100"
                  placeholder="Confirme a senha"
                  type="password"
                />
              </div>
              <div class="col-lg-12 col-xs-12 pt-3">
                <button
                  class="btn-blue-light mt-1 mb-3"
                  style="height: 65%"
                  type="button"
                  @click="validatePassword"
                >
                  <span v-if="!loading_password">SALVAR</span>
                  <div
                    v-if="loading_password"
                    class="spinner-border text-light"
                    role="status"
                  >
                    <span class="sr-only"></span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7 ml-0 pl-0 col-xs-12">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              :class="`nav-link ${tab === 'answers' ? 'active' : ''}`"
              aria-current="page"
              @click="setTab('answers')"
            >
              Respostas
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="`nav-link ${tab === 'experiences' ? 'active' : ''}`"
              @click="setTab('experiences')"
            >
              Experiências
            </a>
          </li>
        </ul>
        <div
          v-if="tab === 'answers'"
          class="cardy-body-noBorder card-light-grey"
          style="height: calc(100% - 48px)"
        >
          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <button
                :disabled="currentEvaluationIndex <= 0"
                aria-label="Avaliação anterior"
                class="btn btn-link p-0"
                title="Avaliação anterior"
                @click="prevEvaluation"
              >
                <i class="fas fa-chevron-left"></i>
              </button>
              <div class="text-center flex-grow-1">
                <span class="color-grey-primary">
                  <b v-if="evaluationGroups.length > 0">
                    AVALIAÇÃO {{ currentEvaluationIndex + 1 }} de
                    {{ evaluationGroups.length }}
                  </b>
                  <b v-else>AVALIAÇÕES</b>
                </span>
              </div>
              <button
                :disabled="
                  currentEvaluationIndex >= evaluationGroups.length - 1
                "
                aria-label="Próxima avaliação"
                class="btn btn-link p-0"
                title="Próxima avaliação"
                @click="nextEvaluation"
              >
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
            <div
              class="d-flex align-items-center justify-content-between mt-2 mb-2"
            >
              <div class="f14 color-grey-primary">
                Nº DE TENTATIVAS RESTANTES: {{ 2 - (view_evaluation || 0) }}
              </div>
              <button
                v-if="2 - (view_evaluation || 0) < 2"
                class="btn btn-primary btn-sm"
                type="button"
                @click="addEvaluationView"
              >
                ADICIONAR MAIS TENTATIVAS
              </button>
            </div>
            <div class="mt-2">
              <div v-if="currentEvaluation.answers.length === 0">
                <h5>O usuário não respondeu a nenhuma questão</h5>
              </div>
              <div
                v-if="evaluation_details(apply, currentEvaluation).count > 0"
                class="mb-1 text-danger"
              >
                O candidato saiu da prova
                {{ evaluation_details(apply, currentEvaluation).count }} vezes
              </div>
              <div v-else>O candidato não saiu da prova</div>
              <div
                v-for="ans in currentEvaluation.answers"
                :key="ans.id"
                class="mb-2"
              >
                <div class="font-weight-bold" v-html="truncate(ans.title)" />

                <div v-if="ans.question.response_type !== 0" class="mb-1 flex">
                  <span><b>Resposta: </b>{{ getAnswer(ans) }}</span>
                  <span v-if="hasCorrectKey(ans.question)" class="mb-1">
                    <RightOrWrongIcons
                      :rightIf="rightAnswer(ans, ans.question)"
                      :wrongIf="!rightAnswer(ans, ans.question)"
                    />
                  </span>
                </div>
                <div v-else class="mb-1">
                  <video
                    v-if="findVideoUrl(ans.id)"
                    controls
                    style="max-height: 300px"
                    width="100%"
                  >
                    <source :src="findVideoUrl(ans.id)" type="video/mp4" />
                  </video>
                  <span v-else><b>Resposta: </b>Não gravou vídeo</span>
                </div>
                <div
                  v-if="
                    ans.question.response_type !== 0 && shouldShowCorrect(ans)
                  "
                  class="mb-1"
                >
                  <span
                    ><b>Resposta correta: </b
                    >{{ getCorrectAnswerText(ans.question) }}</span
                  >
                </div>

                <div>
                  <span class="font-weight-bold">Nota:</span>
                  <span>{{ ans.score || "Não definido" }}</span>
                  <span class="ml-3 font-weight-bold">Descrição:</span>
                  <span>{{ ans.description || "Não definido" }}</span>
                </div>
                <div class="f14">
                  <div>
                    Tempo total:
                    {{ getTimeTaken(ans.created_at, ans.updated_at) }}
                  </div>
                  <div>Início: {{ formattedDateTime(ans.created_at) }}</div>
                  <div>Fim: {{ formattedDateTime(ans.updated_at) }}</div>
                </div>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-primary btn-sm"
                    type="button"
                    @click="deleteAnswer(ans.id)"
                  >
                    APAGAR RESPOSTA
                  </button>
                </div>
                <hr />
              </div>
            </div>
          </div>
          <div v-if="orphanAnswers.length > 0" class="mb-3">
            <div class="text-center flex-grow-1 mb-2">
              <span class="color-grey-primary">
                <b>Perguntas sem avaliação</b>
              </span>
            </div>
            <div class="mt-2">
              <div
                v-for="ans in orphanAnswers"
                :key="`orphan-${ans.id}`"
                class="mb-2"
              >
                <div
                  class="font-weight-bold"
                  v-html="truncate(ans.title)"
                ></div>
                <div v-if="ans.question.response_type !== 0" class="mb-1">
                  <span><b>Resposta: </b>{{ getAnswer(ans) }}</span>
                </div>
                <div v-else class="mb-1">
                  <video
                    v-if="findVideoUrl(ans.id)"
                    controls
                    style="max-height: 300px"
                    width="100%"
                  >
                    <source :src="findVideoUrl(ans.id)" type="video/mp4" />
                  </video>
                  <span v-else><b>Resposta: </b>Não gravou vídeo</span>
                </div>
                <div v-if="hasCorrectKey(ans.question)" class="mb-1">
                  <RightOrWrongIcons
                    :rightIf="rightAnswer(ans, ans.question)"
                    :wrongIf="!rightAnswer(ans, ans.question)"
                  />
                </div>
                <div
                  v-if="
                    ans.question.response_type !== 0 && shouldShowCorrect(ans)
                  "
                  class="mb-1"
                >
                  <span
                    ><b>Resposta correta: </b
                    >{{ getCorrectAnswerText(ans.question) }}</span
                  >
                </div>
                <div>
                  <span class="font-weight-bold">Nota:</span>
                  <span>{{ ans.score || "Não definido" }}</span>
                  <span class="ml-3 font-weight-bold">Descrição:</span>
                  <span>{{ ans.description || "Não definido" }}</span>
                </div>
                <div class="f14">
                  <div>
                    Tempo total:
                    {{ getTimeTaken(ans.created_at, ans.updated_at) }}
                  </div>
                  <div>Início: {{ formattedDateTime(ans.created_at) }}</div>
                  <div>Fim: {{ formattedDateTime(ans.updated_at) }}</div>
                </div>
                <hr />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="tab === 'experiences'"
          class="cardy-body-noBorder card-light-grey"
          style="height: calc(100% - 48px)"
        >
          <AppliesExperiencesTab
            :candidate_id="apply.candidate_id"
            :recruiter_id="recruiter_id"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemTemplate from "components/ItemTemplate.vue";
import moment from "moment";
import BigfiveShow from "@/Bigfives/Show.vue";
import SelectManagers from "components/SelectManagers.vue";
import StarRating from "vue-star-rating";
import ComfirmFeedback from "@/Recruiters/Feedback/Confirm.vue";
import AvaliationLike from "@/ShortlistManagers/AvaliationLike.vue";
import CandidateSkillsRating from "components/CandidateSkillsRating.vue";
import Resume from "@/Recruiters/TalentBank/Candidates/Resume.vue";
import TagList from "./TagList.vue";
import BtnDonwloadCV from "components/ButtonDonwloadCV.vue";
import MultipleChoices from "./MultipleChoices.vue";
import MonetaryType from "./MonetaryType.vue";
import YesOrNo from "./YesOrNo.vue";
import JobExam from "components/JobExam.vue";
import RightOrWrongIcons from "components/RightOrWrongIcons.vue";
import AppliesExperiencesTab from "@/Recruiters/Applies/ExperiencesTab.vue";
import CurriculumUpload from "components/CurriculumUpload.vue";
import VueSuggestion from "components/VueSuggestion.vue";
import { state } from "store/business.js";
import RequestNewAnswer from "../../../components/Communication/RequestNewAnswer.vue";

export default {
  components: {
    StarRating,
    AvaliationLike,
    CandidateSkillsRating,
    BigfiveShow,
    Resume,
    SelectManagers,
    BtnDonwloadCV,
    MultipleChoices,
    YesOrNo,
    MonetaryType,
    JobExam,
    RightOrWrongIcons,
    AppliesExperiencesTab,
    CurriculumUpload,
    VueSuggestion,
  },
  props: [
    "apply_id",
    "candidate_id",
    "job_id",
    "job_name",
    "job_url",
    "applies",
    "index",
    "job",
    "user_manager",
    "shortlist_uid",
    "is_recruiter",
    "recruiter_id",
    "manager_id",
    "talent_bank_id",
    "current",
    "hitsPercentage",
    "account_uid",
    "is_limited",
  ],
  data: () => ({
    edit_name: false,
    edit_email: false,
    edit_number: false,
    managers: [],
    showTags: false,
    message: "",
    time_taken: 0,
    jobs: [],
    whatsapp: "",
    borderColor: "",
    job_selected: {},
    load: true,
    candidate: {},
    answers: [],
    questions: [],
    sent_email: 0,
    show_resume: false,
    answer_current: 0,
    avatar: "",
    comment: "",
    comments: [],
    import_answer: 0,
    portfolio: "",
    rating: 0,
    rating_agg: 0,
    answers_videos: [],
    resume: "",
    title_email: "",
    text_email: "",
    index_current: 0,
    apply: {},
    view_evaluation: 0,
    select_process_id: 0,
    select_process: [],
    itemTemplate,
    recruiter_name: "",
    recruiter: true,
    load_share: false,
    load_copy: false,
    load_candidate: true,
    url_share: "",
    colorBorder: "",
    tagName: "",
    tagColor: "",
    visibility: false,
    show_candidate_data: false,
    tab: "answers",
    password: "",
    confirm_password: "",
    loading_password: "",
    state: state,
    score: null,
    description: null,
    shortlist: null,
    shortlists: [],
    shortlist_name: null,
    ethnicities: [
      { value: 1, label: "Branca" },
      { value: 2, label: "Preta" },
      { value: 3, label: "Parda" },
      { value: 5, label: "Prefiro não responder" },
      { value: 7, label: "Amarela" },
      { value: 8, label: "Indígena" },
      { value: 9, label: "Outra" },
    ],
    sexual_orientations: [
      { value: 0, label: "HETEROSSEXUAL" },
      { value: 1, label: "BISSEXUAL" },
      { value: 2, label: "PANSEXUAL" },
      { value: 4, label: "HOMOSSEXUAL" },
      { value: 5, label: "ASSEXUAL" },
      { value: 6, label: "OUTRO" },
      { value: 3, label: "PREFIRO NÃO INFORMAR" },
    ],
    genders: [
      {
        value: 0,
        label: "CISGÊNERO MASCULINO",
      },
      {
        value: 1,
        label: "CISGÊNERO FEMININO",
      },
      {
        value: 2,
        label: "TRANSGÊNERO",
      },
      {
        value: 4,
        label: "NÃO-BINÁRIO",
      },
      {
        value: 10,
        label: "OUTROS",
        tooltip_text: "",
      },
      {
        value: 3,
        label: "PREFIRO NÃO ME IDENTIFICAR",
      },
    ],
    custom_flags: null,
    currentEvaluationIndex: 0,
  }),
  computed: {
    evaluationGroups() {
      if (!this.answers || this.answers.length === 0) return [];
      const map = {};
      for (const ans of this.answers) {
        const evId = ans?.question?.evaluation_id;
        if (!evId) continue;
        if (!map[evId]) map[evId] = [];
        map[evId].push(ans);
      }
      const ids = Object.keys(map);
      return ids.map((id) => ({ id, answers: map[id] }));
    },
    currentEvaluation() {
      const groups = this.evaluationGroups;
      if (groups.length === 0) return { id: null, answers: [] };
      const idx = Math.max(
        0,
        Math.min(this.currentEvaluationIndex, groups.length - 1)
      );
      return groups[idx];
    },
    orphanAnswers() {
      if (!this.answers || this.answers.length === 0) return [];
      return this.answers.filter((ans) => !ans?.question?.evaluation_id);
    },
  },
  methods: {
    evaluation_details(details, evaluation) {
      if (!evaluation || !details || !details.evaluation_details) {
        return { count: 0 };
      }

      const match = details.evaluation_details.find(
        (item) => parseInt(item.evaluation_id) === parseInt(evaluation.id)
      );

      return match || { count: 0 };
    },
    updateName() {
      axios
        .put(`/api/v1/recruiters/candidates/${this.candidate_id}`, {
          name: this.candidate.name,
        })
        .then((response) => {
          this.candidate.name = response.data.candidate.name;
          this.edit_name = false;
          this.$toast.success("Nome alterado com sucesso!");
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao salvar nome do candidato(a)");
        });
    },
    updateEmail() {
      axios
        .put(`/api/v1/recruiters/candidates/${this.candidate_id}`, {
          email: this.candidate.email,
        })
        .then((response) => {
          this.candidate.email = response.data.candidate.email;
          this.edit_email = false;
          this.$toast.success("Email alterado com sucesso!");
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao salvar Email do candidato(a)");
        });
    },
    updatePhone() {
      axios
        .put(`/api/v1/recruiters/candidates/${this.candidate_id}`, {
          mobile_phone: this.candidate.mobile_phone,
        })
        .then((response) => {
          this.candidate.mobile_phone = response.data.candidate.mobile_phone;
          this.edit_number = false;
          this.$toast.success("Telefone alterado com sucesso!");
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao salvar Telefone do candidato(a)");
        });
    },
    deleteAnswer(id) {
      axios
        .delete(`/recruiters/answers/${id}`)
        .then((res) => {
          this.answers = this.answers.filter((ans) => ans.id !== id);
          this.$modal.show(
            RequestNewAnswer,
            {
              candidate: this.candidate,
              no_next: true,
              only_graph: false,
            },
            {
              width: "60%",
              height: "auto",
              scrollable: true,
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    prevEvaluation() {
      if (this.currentEvaluationIndex > 0) this.currentEvaluationIndex -= 1;
    },
    nextEvaluation() {
      if (this.currentEvaluationIndex < this.evaluationGroups.length - 1)
        this.currentEvaluationIndex += 1;
    },
    rightAnswer(answer, question) {
      if (answer.choices == null) {
        return false;
      }

      if (!answer.choices?.marked) {
        answer.choices.marked = [];
      }

      if (question.response_type == 3) {
        return answer.choices?.marked.includes(question.choices.correctAnswer);
      }

      let titles = question.choices.rightAnswer.titles;
      let right = false;
      for (let option of answer.choices.marked) {
        right = titles.includes(option);
        if (right) break;
      }
      return right;
    },
    shouldShowCorrect(ans) {
      const q = ans && ans.question ? ans.question : null;
      if (!q || !q.choices) return false;
      if (q.response_type === 2) {
        if (!q.choices.rightAnswer || !q.choices.rightAnswer.titles)
          return false;
        if (
          !Array.isArray(q.choices.rightAnswer.titles) ||
          q.choices.rightAnswer.titles.length === 0
        )
          return false;
        return !this.rightAnswer(ans, q);
      }
      if (q.response_type === 3) {
        if (
          q.choices.correctAnswer === undefined ||
          q.choices.correctAnswer === null ||
          q.choices.correctAnswer === "any"
        )
          return false;
        const marked = ans && ans.choices ? ans.choices.marked : [];
        const isRight = Array.isArray(marked)
          ? marked.includes(q.choices.correctAnswer)
          : marked === q.choices.correctAnswer;
        return !isRight;
      }
      return false;
    },
    hasCorrectKey(q) {
      if (!q || !q.choices) return false;
      if (q.response_type === 2) {
        const ra = q.choices.rightAnswer;
        return !!(ra && Array.isArray(ra.titles) && ra.titles.length > 0);
      }
      if (q.response_type === 3) {
        const ca = q.choices.correctAnswer;
        return ca !== undefined && ca !== null && ca !== "any";
      }
      return false;
    },
    getCorrectAnswerText(question) {
      if (!question || !question.choices) return "";
      if (question.response_type === 2) {
        const titles =
          question.choices.rightAnswer && question.choices.rightAnswer.titles
            ? question.choices.rightAnswer.titles
            : [];
        return Array.isArray(titles) ? titles.join(", ") : "";
      }
      if (question.response_type === 3) {
        const ca = question.choices.correctAnswer;
        if (ca === "yes") return "Sim";
        if (ca === "no") return "Não";
        return "";
      }
      return "";
    },
    haveRightAnswer(choices, response_type, index) {
      if (response_type != 2) return;
      let options = choices.options;

      let rightOptions = options.filter((el) => el.rightAnswer);

      this.answers[index].question.choices.rightAnswer = {
        haveOne:
          rightOptions.length > 0 && rightOptions.length != options.length,
        titles: rightOptions.map((option) => option.title),
      };
    },
    prepareRightAnswers() {
      if (!this.answers || this.answers.length === 0) return;
      for (let i = 0; i < this.answers.length; i++) {
        const ans = this.answers[i];
        const q = ans?.question;
        if (!q) continue;
        if (q.response_type === 2 && q.choices && q.choices.options) {
          this.haveRightAnswer(q.choices, q.response_type, i);
        }
      }
    },
    setWppNumber(value) {
      if (!value) {
        return "";
      }
      let characters = ["(", ")", "-", " "];
      for (let char of characters) {
        value = value.replaceAll(char, "");
      }
      this.whatsapp = value;
    },
    add_uid(url) {
      return this.account_uid ? `${url}/${this.account_uid}` : url;
    },
    showBigfive() {
      this.$modal.show(
        BigfiveShow,
        {
          candidate_uid: this.candidate.uid,
          no_next: true,
          only_graph: false,
        },
        {
          width: "60%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    truncate(title) {
      return title.length > 200
        ? title.slice(0, 200).trim().concat("...")
        : title;
    },
    showTagOverview() {
      this.$modal.show(
        TagList,
        {
          apply_id: this.apply_id,
          candidate_id: this.candidate_id,
        },
        {
          width: "30%",
          height: "auto",
          scrollable: true,
        }
      );
    },
    confirmFeedback(feedbackParam, select_process_id) {
      const feedback = JSON.parse(feedbackParam);

      let candidate = {};
      if (this.applies[this.index_current].name) {
        candidate = {
          candidate_id: this.applies[this.index_current].candidate_id,
          name: this.applies[this.index_current].name,
          email: this.applies[this.index_current].email,
          image: this.applies[this.index_current].image,
        };
      } else {
        candidate = {
          candidate_id: this.applies[this.index_current].candidate_id,
          name: this.applies[this.index_current].candidate_name,
          email: this.applies[this.index_current].candidate_email,
          image: this.applies[this.index_current].image,
        };
      }

      this.$modal.show(
        ComfirmFeedback,
        {
          status: true,
          candidates: [candidate],
          feedback: feedback,
          feedback_selective_process: {
            selective_process_id: select_process_id,
          },
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          clickToClose: false,
        }
      );
    },
    findVideoUrl(answer_id) {
      const videoObj = this.answers_videos.find(
        (video) => video.answer_id === answer_id
      );

      return videoObj ? videoObj.url : null;
    },
    shareCandidate() {
      this.load_share = true;
      if (!this.shortlist?.id) {
        this.load_share = false;
        return this.$toast.error("Selecione uma lista de candidatos");
      }
      eventBus.$emit("getManagers");
      if (this.managers.length === 0) return;

      axios
        .post("/recruiters/manager", {
          manager: { managers: this.managers },
          shortlist: {
            id: this.shortlist?.id,
            job_id: this.apply.job_id,
          },
          message: {
            text: this.message,
          },
        })
        .then((response) => {
          this.url_share = response.data.url;
          axios
            .post(
              `/recruiters/shortlists/${response.data.shortlist.id}/candidates`,
              {
                candidates: {
                  apply_ids: [this.apply.id],
                  select_process_id: this.apply.selective_process_id,
                },
              }
            )
            .then((resp) => {
              this.getShortlists();
              this.load_share = false;
              this.$toast.success("Candidato(a) compartilhado com sucesso");
            });
        });
      this.load_share = false;
    },
    copyCandidate() {
      this.load_copy = true;
      let candidates = [
        {
          id: this.candidate_id,
          remuneration: this.apply.remuneration,
        },
      ];

      axios
        .post("/recruiters/copy_candidates", {
          apply: {
            candidates,
            job_id: this.job_selected.id,
            business_id: this.apply.business_id,
            last_apply_id: this.apply.id,
            import_answer: this.import_answer,
            visibility: this.visibility,
          },
        })
        .then((response) => {
          this.load_copy = false;
          if (response.data.status) {
            this.$toast.success("Candidato(a) copiado com sucesso");
          }
        })
        .catch((error) => {
          this.$toast.error(
            "erro ao copiar candidato(a), por favor tente novamente mais tarde"
          );
          this.load_copy = false;
        });
    },
    itemSelected(item) {
      this.job_selected = item;
      this.title_email = `Vaga de ${this.job_selected.title} para você ${this.candidate.name} `;
      this.text_email = `Olá ${this.candidate.name} tudo bom?\nMeu nome é ${this.recruiter_name}, e estou recrutando para a vaga de ${this.job_selected.title}, acredito que você tem perfil para isso.\ncaso tenha interessa se candidate no link abaixo\n\n${this.job_selected.url}`;
    },
    setLabel(item) {
      return item.title;
    },
    inputChange(text) {
      axios
        .get(`/recruiters/jobs_search?term=${text}&this_job=${this.job_id}`)
        .then((response) => {
          this.jobs = response.data.jobs;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD HH").format("DD/MM/YYYY HH") + "h";
    },
    formattedDateTime(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    },
    getTimeTaken(start, end) {
      const start_date = new Date(start);
      const end_date = new Date(end);

      const time_taken = Math.abs(end_date - start_date);

      return new Date(time_taken).toISOString().substr(11, 8);
    },
    getRatingAgg(answer_id) {
      axios
        .get(this.add_uid(`/recruiters/ratings/${answer_id}`))
        .then((response) => {
          this.rating_agg = 0;
          if (response.data.rating)
            this.rating_agg = parseInt(response.data.rating);
        });
    },
    haveNext() {
      if (this.applies[this.index_current + 1]) {
        return this.applies[this.index_current + 1];
      }
      return false;
    },
    havePrevius() {
      if (this.applies[this.index_current - 1]) {
        return this.applies[this.index_current - 1];
      }
      return false;
    },
    nextCandidate(apply, change) {
      if (!apply) return false;

      this.index_current = this.index_current + change;
      if (this.user_manager) {
        this.answer_current = 0;
        this.loadCandidate(apply.uid, apply.candidate_uid);
        return;
      }
      this.loadCandidate(apply.id, apply.candidate_id);
    },
    loadComments(answer_id) {
      axios
        .get(this.add_uid(`/recruiters/comments/${answer_id}/desc`))
        .then((response) => {
          if (this.comments.length != response.data.comments.length) {
            this.comments = response.data.comments;
          }
        });
    },
    nextVideo(index) {
      this.rating = 0;
      this.answer_current = index;
      let video = document.getElementById("video_answers");
      this.loadComments(this.answers[this.answer_current].id);
      this.getRatingAgg(this.answers[this.answer_current].id);
      if (video) {
        video.load();
      }
    },
    updateApply() {
      if (!this.recruiter_id) {
        return;
      }
      if (this.select_process_id != this.apply.selective_process_id) {
        this.apply.status = 2;
      }

      axios
        .put(`/recruiters/applies/${this.apply.id}`, {
          applies: {
            selective_process_id: this.select_process_id,
            status: this.apply.status,
          },
          feedback: {
            selective_process_id: this.select_process_id,
            job_id: this.job_id,
          },
        })
        .then((response) => {
          const data = JSON.stringify(response.data.feedback, null, 2);

          if (response.data.feedback) {
            this.confirmFeedback(data, this.select_process_id);
            return;
          }

          if (response.data.applies.status == 2) {
            this.$toast.success("Processo seletivo atualizado com sucesso");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Erro ao atualizar processo seletivo");
        });
    },
    loadCandidate(apply_id, candidate_id) {
      let url = `/shortlist_managers/${this.job_id}/${apply_id}/${candidate_id}`;
      if (!this.user_manager) {
        url = `/recruiters/jobs/${this.job_id}/applies/${apply_id}/${candidate_id}`;
      }

      url = this.add_uid(url);
      this.load_candidate = true;
      axios.get(url).then((response) => {
        this.answers_videos = response.data.answer_video_url;
        this.answers = response.data.answers;
        this.time_taken = response.data.time_taken;
        this.candidate = response.data.candidate;
        this.resume = response.data.resume;
        this.avatar = response.data.avatar || "/images/avatar.png";

        this.answers.map((answer, index) =>
          this.haveRightAnswer(
            answer.question.choices,
            answer.question.response_type,
            index
          )
        );
        if (this.answers[this.answer_current]) {
          this.score = this.answers[this.answer_current].score;
          this.description = this.answers[this.answer_current].description;
        }
        this.setWppNumber(this.candidate.mobile_phone);

        this.portfolio = response.data.portfolio_istrue.mandatory_portfolio;
        this.load = false;
        this.apply = response.data.apply;

        this.select_process_id = response.data.apply.selective_process_id;

        this.select_process = response.data.select_process;
        this.recruiter_name = response.data.recruiter_name;

        if (this.apply.tag_apply != null) {
          this.colorBorder = this.apply.tag_apply.tag.color;
          this.tagName = this.apply.tag_apply.tag.name;
          this.tagColor = this.apply.tag_apply?.tag?.color;
        }

        this.prepareRightAnswers();
        if (this.answers.length > 0) {
          this.loadComments(this.answers[this.answer_current].id);
          this.getRatingAgg(this.answers[this.answer_current].id);
          this.nextVideo(0);
        }

        this.view_evaluation = response.data.candidate.view_evaluation;

        this.job_selected = {};
        if (this.apply.status == 0) {
          this.apply.status = 1;
          this.updateApply();
        }
        this.load_candidate = false;

        if (this.current !== undefined) {
          for (let i = 0; i < this.answers.length; i++) {
            if (this.answers[i].id == this.current) {
              this.answer_current = i;
              this.nextVideo(i);
            }
          }
        }
      });
    },
    loadQuestions(job_id) {
      if (this.is_recruiter) {
        axios.get(`/recruiters/questions/${this.job_id}`).then((response) => {
          this.questions = response.data.questions;
        });
      }
    },
    answered(title) {
      for (let answer of this.answers) {
        if (title === answer.title) return true;
      }

      return false;
    },
    getGender(gender_id) {
      if (gender_id === null || gender_id < 0) return "Não informado";
      const found = this.genders?.find((gender) => gender.value === gender_id);
      return found?.label || "Não informado";
    },
    getEthnicity(ethnicity_id) {
      if (ethnicity_id === null || ethnicity_id < 0) return "Não informado";
      const found = this.ethnicities?.find(
        (ethnicity) => ethnicity.value === ethnicity_id
      );
      return found?.label || "Não informado";
    },
    getSexualOrientation(sexual_orientation_id) {
      if (sexual_orientation_id === null || sexual_orientation_id < 0)
        return "Não informado";

      return this.sexual_orientations?.find(
        (sexual_orientation) =>
          sexual_orientation.value === sexual_orientation_id
      ).label;
    },
    addEvaluationView() {
      axios
        .put(`/recruiters/talent_banks/${this.candidate_id}/candidate/edit`, {
          candidates: {
            view_evaluation: 0,
          },
        })
        .then(() => {
          this.$toast.success(
            "Foi concedida mais uma tentativa a esse(a) candidato(a)"
          );
          this.view_evaluation = 0;
        });
    },
    setTab(tab) {
      this.tab = tab;
    },
    getCustomFlags() {
      axios
        .get(`/recruiters/job/${this.job_id}/custom_flags`)
        .then((response) => {
          this.custom_flags = response.data.custom_flags;
        });
    },
    validatePassword() {
      let confirm = window.confirm(
        "Tem certeza que deseja alterar a senha do candidato"
      );
      if (confirm) {
        this.loading_password = true;
        if (this.password.length <= 6) {
          this.$toast.error("SENHA DEVE SER MAIOR QUE 6 CARACTERES");
          this.loading_password = false;
          return false;
        }
        if (this.password != this.confirm_password) {
          this.$toast.error("SENHA E CONFIRMAÇÃO DE SENHA ESTÃO DIFERENTES");
          this.loading_password = false;
          return false;
        }
        axios
          .put(`/recruiters/talent_banks/${this.candidate_id}/candidate/edit`, {
            candidates: {
              password: this.password,
            },
          })
          .then(() => {
            this.$toast.success("SENHA ALTERADA COM SUCESSO!");
            this.loading_password = false;
            this.password = "";
            this.confirm_password = "";
          });
      }
    },
    getAnswer(answer) {
      if (answer.question.response_type === 3) {
        return answer.choices?.marked === "yes" ? "Sim" : "Não";
      }
      if (answer.question.response_type === 2) {
        const marked = answer?.choices?.marked;
        if (Array.isArray(marked)) return marked.join(", ");
        if (typeof marked === "string") return marked;
        return "Não respondido.";
      }
      if (answer.question.response_type === 1) {
        return answer.choices?.text || "Não respondido.";
      }
      return "";
    },
    setExtraOptions() {
      if (this.state.extra_options) {
        this.state.extra_options?.ethnicity?.length > 0
          ? (this.ethnicities = this.state.extra_options?.ethnicity?.map(
              (ethnicity, index) => {
                return { name: ethnicity, id: index };
              }
            ))
          : this.ethnicities;

        this.state.extra_options?.sexual_orientation?.length > 0
          ? (this.sexual_orientations =
              this.state.extra_options?.sexual_orientation?.map(
                (sexual_orientation, index) => {
                  return { name: sexual_orientation, id: index };
                }
              ))
          : this.sexual_orientations;
      }
    },
    createShortlist() {
      this.load_share = true;
      if (!this.shortlist_name) {
        this.load_share = false;
        return this.$toast.error("Digite um nome para a lista de candidatos");
      }
      axios
        .post("/recruiters/shortlists", {
          shortlist: {
            job_id: this.job_id,
            name: this.shortlist_name,
          },
        })
        .then((response) => {
          this.shortlists.push(response.data.shortlist);
          this.load_share = false;
        });
    },
    removeShortlist(index, id) {
      let conf = confirm(
        "Tem certeza que deseja remover esta lista de candidatos?"
      );
      if (!conf) return;
      axios.delete(`/recruiters/shortlists/${id}`).then((response) => {
        this.shortlists.splice(index, 1);
      });
    },
    shortlistSelected(item) {
      this.shortlist = item;
    },
    removeManager(index, manager_index, id) {
      let conf = confirm("Tem certeza que deseja remover este gestor?");
      if (!conf) return;
      axios.delete(`/recruiters/shortlist_managers/${id}`).then((response) => {
        this.shortlists[index].managers.splice(manager_index, 1);
        this.$toast.success("Gestor(a) removido com sucesso");
      });
    },
    getShortlists() {
      axios
        .get(`/recruiters/shortlists?search=*&job_id=${this.job_id}`)
        .then((response) => {
          this.shortlists = response.data.shortlists;
        });
    },
    onCopy() {
      this.$toast.success("LINK COPIADO COM SUCESSO");
    },
    openWhatsappSolcitation() {
      if (!this.whatsapp) {
        return this.$toast.error(
          "Candidato(a) não possui número de whatsapp cadastrado"
        );
      }
      axios.get("/recruiters/profile/info").then((response) => {
        const recruiter_name = response.data.name;
        const business_name = response.data.business_name;
        const text = `Olá ${this.candidate.name}, tudo bem? Sou ${recruiter_name} da empresa Mappit e falo em nome da ${business_name}, gostaria de falar com você sobre a vaga de ${this.job_name} que você se candidatou. Parece que você ainda não respondeu todas as questões necessárias para seguir com o processo. Por favor, acesse ${this.job_url} e responda todas as questões solicitadas.`;
        window.open(
          `https://api.whatsapp.com/send?phone=55${this.whatsapp}&text=${text}`
        );
      });
    },
  },
  watch: {
    "state.extra_options"() {
      this.setExtraOptions();
    },
    answer_current() {
      if (this.answers[this.answer_current]) {
        this.score = this.answers[this.answer_current].score;
        this.description = this.answers[this.answer_current].description;
        return;
      }
      this.score = null;
      this.description = null;
    },
  },
  mounted() {
    this.getShortlists();
    this.index_current = this.index;
    this.loadCandidate(this.apply_id, this.candidate_id);
    this.loadQuestions();
    this.getCustomFlags();
    eventBus.$emit("setDraggable", false);

    eventBus.$on("setTag", (color, name) => {
      this.colorBorder = color;
      this.tagName = name;
    });

    if (this.is_recruiter === false || this.is_recruiter === true) {
      this.recruiter = this.is_recruiter;
    }
    if (this.answers.length != 0) {
      if (this.answers[this.answer_current].id) {
        this.loadComments(this.answers[this.answer_current].id);
      }
    }

    this.setExtraOptions();
  },
};
</script>

<style scoped>
.nav-link {
  background-color: transparent !important;
  cursor: pointer;
}
.nav-link.active {
  background-color: #e6e6e6 !important;
}

.content-items {
  width: 100%;
  max-width: 300px;
}
.relative {
  position: relative;
}
.top-30 {
  top: 30px;
}
</style>
